import useRoutesResolver from 'core/routing/hooks/use-routes-resolver';
import { ISSUER_ROUTES } from './routes.config';
import type { DistributionPlatform, Feature, User, EnvironmentPermissionsEnum } from 'api';

export function useIssuerNavigationItems({
  currentUser,
  hasIssuersToView,
  configFeatures,
  distributionPlatforms,
  environmentPermissions,
  canCreateProducts,
}: {
  currentUser: User | null;
  hasIssuersToView: boolean;
  configFeatures: Feature;
  distributionPlatforms: DistributionPlatform[];
  environmentPermissions: EnvironmentPermissionsEnum[];
  canCreateProducts: boolean;
}) {
  return useRoutesResolver(ISSUER_ROUTES, {
    currentUser,
    hasIssuersToView,
    displayAllRoutes: true,
    configFeatures,
    distributionPlatforms,
    environmentPermissions,
    canCreateProducts,
  });
}
